var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.statementString),expression:"statementString"}],attrs:{"id":"statement-viewer"}},[_vm._v("    "),_c('code',{staticClass:"json"}),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }